import {ProductType} from "./ProductType";
import {CustomerProductItem} from "./CustomerProductItem";
import {Charger} from "../../Ope/Charger/Charger";

export class ProductItemChargerRelationDTO {
  public chargerType!: Charger;
  public productItem!: CustomerProductItem;
  public id!: number;
  public taIndex!: number;
  public chargerCount!: number
}
